import { Dialog, DialogProps } from "../core/components/dialog.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Helper } from "../core/util/helper.js";
import { FieldInstance } from "../core/components/field.js";
import { IconsComboBox } from "../core/components/iconComboBox.js";
import { IconPicker } from "../core/components/iconPicker.js";
import { ComboBox } from "../core/components/comboBox.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { TextBox } from "../core/components/textBox.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Context } from "../core/components/commonApp.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react"
import ReactDOM from "react-dom";

interface EditBookmarksProps {
    categories: BookmarkCategory[]
}
interface EditBookmarksState {
    categories: BookmarkCategory[];
    draggedBookmark: Bookmark;
    draggedCategory: BookmarkCategory;
}
interface BookmarkCategory extends IBaseBookmark {
    Bookmarks: Bookmark[];
}
interface Bookmark extends IBaseBookmark {
    CategoryId: string;
    URL: string;
}
interface IBaseBookmark {
    Icon: string;
    Id: string;
    Name: string;
    Pos: number;
    PwUser: string
}

const sortByPos = (a: IBaseBookmark, b: IBaseBookmark) => {
    if (a.Pos < b.Pos) {
        return -1;
    } else if (a.Pos > b.Pos) {
        return 1;
    }
    // a must be equal to b
    return 0;
}

export class EditBookmarks extends React.Component<EditBookmarksProps, EditBookmarksState> {
    private categoriesToSave: string[] = [];
    private MAXLENGTH = Config.settings.bookmarks.maxAmount;
    constructor(props: EditBookmarksProps) {
        super(props)
        const categories = props.categories.sort(sortByPos);
        for (let i = 0; i < categories.length; i++) {
            categories[i].Bookmarks = categories[i].Bookmarks.sort(sortByPos)
        }
        this.state = {
            categories: categories,
            draggedBookmark: null,
            draggedCategory: null,
        }
        const header = document.querySelector(".sheet__title");
        header.innerHTML = `<div class="sheet__title__label">
            <div class="sheet__title__label__text truncate">
                <label title="${Helper.getTranslation("Bookmarks.EditMyBookmarks")}">${Helper.getTranslation("Bookmarks.EditMyBookmarks")}</label>
            </div><div class="sheet__title__label_remarks">
           </div>`//`
    }

    private updateCategories = (categories: BookmarkCategory[]) => {
        categories = categories.sort(sortByPos);
        for (let i = 0; i < categories.length; i++) {
            categories[i].Pos = i;
            categories[i].Bookmarks = categories[i].Bookmarks.sort(sortByPos)
            for (let ii = 0; ii < categories[i].Bookmarks.length; ii++) {
                categories[i].Bookmarks[ii].Pos = ii;
            }
        }
        this.setState({ categories: categories })
    }

    private renderCategory = (cat: BookmarkCategory) => {
        const clear = (save: boolean) => {
            this.setState({ draggedBookmark: null, draggedCategory: null }, async () => {
                if (save)
                    await this.save()
            })
        }
        const onCategoryDrop = () => {
            this.moveDraggedBookmarkToAnotherCategory(cat.Id);
            clear(true)
        }
        return (
            <React.Fragment key={cat.Id}>
                <Category
                    category={cat}
                    draggedBookmark={this.state.draggedBookmark}
                    draggedCategory={this.state.draggedCategory}
                    onCategoryDrop={onCategoryDrop}
                    onDragStart={() => { this.setState({ draggedCategory: cat }) }}
                    onDragEnd={() => { clear(false) }}
                    onDragEnter={() => { this.onCategoryDragEnter(cat) }}
                    onDrop={() => { clear(true) }}
                    delete={() => { this.deleteCategory(cat) }}
                    edit={() => { this.editCategory(cat) }}
                >
                    {cat.Bookmarks.map(this.renderBookmark)}
                </Category>
            </React.Fragment>
        );
    }

    private deleteCategory = async (category: BookmarkCategory) => {
        const categories = this.state.categories.filter(cat => cat.Id != category.Id);
        this.updateCategories(categories);
        const { Code, Message } = await HTTPService.get<JsonResultClass>("Bookmark/DeleteCategory?id=" + category.Id);
        if (Code != 0)
            NotificationHelper.showErrorMessage(Message)
        else
            NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))

        this.setState({ draggedBookmark: null, draggedCategory: null });
    }

    private editCategory = async (category: BookmarkCategory) => {
        const title = Helper.getTranslation("Bookmarks.Edit").replace("{x}", category.Name);
        const cat = await this.openDialog<BookmarkCategory>(category, title);

        const dublicate = this.state.categories.find(c => c.Name.trim() == cat.Name.trim() && c.Id != cat.Id);
        if (Helper.hasValue(dublicate)) {
            const msg = Helper.getTranslation("Bookmarks.CategoryAlreadyExists").replace("{x}", dublicate.Name);
            NotificationHelper.showWarningMessage(msg);
            return;
        }



        if (Helper.hasValue(cat)) {
            const categories = this.state.categories;
            const index = categories.findIndex(f => f.Id == category.Id);
            categories[index].Name = cat.Name;
            categories[index].Icon = cat.Icon;
            const { Code, Message } = await HTTPService.post("Bookmark/UpdateCategory", {
                category: categories[index]
            });
            if (Code != 0)
                NotificationHelper.showErrorMessage(Message)
            this.updateCategories(categories);
            this.setState({ draggedBookmark: null, draggedCategory: null });
        }
    }

    private renderBookmark = (bookmark: Bookmark) => {
        return (
            <React.Fragment key={bookmark.Id}>
                <BookmarkView
                    draggedId={Helper.hasValue(this.state.draggedBookmark) ? this.state.draggedBookmark.Id : null}
                    bookmark={bookmark}
                    onDragStart={() => { this.setState({ draggedBookmark: bookmark, draggedCategory: null }) }}
                    onDragEnd={() => { this.setState({ draggedBookmark: null, draggedCategory: null }) }}
                    onDragEnter={() => { this.onDragEnter(bookmark) }}
                    onDrop={async () => { await this.save(); this.setState({ draggedBookmark: null, draggedCategory: null }) }}
                    delete={() => { this.deleteBookmark(bookmark) }}
                    edit={() => { this.editBookmark(bookmark) }}
                />

            </React.Fragment>
        );
    }

    private save = async () => {
        let a = this.categoriesToSave.length > 0 ? this.state.categories.find(cat => cat.Id == this.categoriesToSave[0]) : null;
        let b = this.categoriesToSave.length > 1 ? this.state.categories.find(cat => cat.Id == this.categoriesToSave[1]) : null;
        await BookmarkService.updateCategories(a, b);
    }

    private editBookmark = async (bookmark: Bookmark) => {
        const title = Helper.getTranslation("Bookmarks.Edit").replace("{x}", bookmark.Name);
        const bm = await this.openDialog<Bookmark>(bookmark, title);
        if (Helper.hasValue(bm)) {
            const categories = this.state.categories;
            const indexA = categories.findIndex(cat => cat.Id == bookmark.CategoryId);
            const indexB = categories[indexA].Bookmarks.findIndex(bm => bm.Id == bookmark.Id);
            categories[indexA].Bookmarks[indexB].Icon = bm.Icon;
            categories[indexA].Bookmarks[indexB].Name = bm.Name;
            categories[indexA].Bookmarks[indexB].URL = bm.URL;
            const { Code, Message } = await HTTPService.post("Bookmark/UpdateBookmark", {
                bookmark: categories[indexA].Bookmarks[indexB]
            });
            if (Code != 0)
                NotificationHelper.showErrorMessage(Message)
            else
                NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))
            this.updateCategories(categories);
            this.setState({ draggedBookmark: null, draggedCategory: null });
        }
    }

    private deleteBookmark = async (bookmark: Bookmark) => {
        const categories = this.state.categories;
        const index = categories.findIndex(cat => cat.Id == bookmark.CategoryId)
        categories[index].Bookmarks = categories[index].Bookmarks.filter(bm => bm.Id != bookmark.Id);
        const { Code, Message } = await HTTPService.get<JsonResultClass>("Bookmark/DeleteBookmark?id=" + bookmark.Id);
        if (Code != 0)
            NotificationHelper.showErrorMessage(Message)
        else
            NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))
        this.updateCategories(categories);
    }

    private onCategoryDragEnter = (category: BookmarkCategory) => {
        if (category.Id != this.state.draggedCategory.Id) {
            this.categoriesToSave = JSON.parse(JSON.stringify([category.Id, this.state.draggedCategory.Id]));
            const categories = this.state.categories;
            const indexA = categories.findIndex(bm => bm.Id == category.Id);
            const indexB = categories.findIndex(bm => bm.Id == this.state.draggedCategory.Id);
            const tmpPos = categories[indexA].Pos;
            categories[indexA].Pos = categories[indexB].Pos;
            categories[indexB].Pos = tmpPos;
            this.updateCategories(categories);
        }
    }

    private onDragEnter = (bookmark: Bookmark) => {
        if (Helper.hasValue(this.state.draggedBookmark) && bookmark.Id != this.state.draggedBookmark.Id) {
            const categories = this.state.categories;
            if (this.state.draggedBookmark.CategoryId == bookmark.CategoryId) {
                const categoryIndex = categories.findIndex(cat => cat.Id == bookmark.CategoryId)
                const category = categories[categoryIndex];
                const indexA = category.Bookmarks.findIndex(bm => bm.Id == bookmark.Id);
                const indexB = category.Bookmarks.findIndex(bm => bm.Id == this.state.draggedBookmark.Id);

                const tmpPos = category.Bookmarks[indexA].Pos;
                category.Bookmarks[indexA].Pos = category.Bookmarks[indexB].Pos;
                category.Bookmarks[indexB].Pos = tmpPos;

                categories[categoryIndex] = category;
                this.categoriesToSave = [category.Id];
                this.updateCategories(categories);
            } else {

                this.moveDraggedBookmarkToAnotherCategory(bookmark.CategoryId, bookmark.Pos);
            }
        }
    }

    private moveDraggedBookmarkToAnotherCategory = (categoryId: string, pos: number = null) => {
        this.categoriesToSave = JSON.parse(JSON.stringify(
            [
                categoryId,
                this.state.draggedBookmark.CategoryId
            ]
        ));
        /*Remove from old*/
        const categories = this.state.categories;
        const prevCategoryIndex = categories.findIndex(cat => cat.Id == this.state.draggedBookmark.CategoryId);
        const prevCategory = categories[prevCategoryIndex];
        prevCategory.Bookmarks = prevCategory.Bookmarks.filter(bm => bm.Id != this.state.draggedBookmark.Id);
        categories[prevCategoryIndex] = prevCategory;


        const nextCategoryIndex = categories.findIndex(cat => cat.Id == categoryId);
        const nextCategory = categories[nextCategoryIndex];
        if (!Helper.hasValue(pos)) {
            pos = Math.max(...nextCategory.Bookmarks.map(bm => bm.Pos)) + 1;

        }
        const dragged = this.state.draggedBookmark;
        dragged.CategoryId = categoryId;
        dragged.Pos = pos;
        for (let i = 0; i < nextCategory.Bookmarks.length; i++) {
            if (nextCategory.Bookmarks[i].Pos >= pos) {
                nextCategory.Bookmarks[i].Pos += 1;
            }
        }
        nextCategory.Bookmarks.push(dragged);
        categories[nextCategoryIndex] = nextCategory;
        this.setState({ draggedBookmark: dragged }, () => {
            this.updateCategories(categories);
        })
    }

    private renderNewCategoryBtn = () => {
        if (this.state.categories.length >= this.MAXLENGTH) {
            return null;
        }
        const createNewCategory = async () => {
            const title = Helper.getTranslation("Bookmarks.NewCategory");
            const result = await this.openDialog({ Icon: "circle-bookmark", Id: "", Name: "New category", Pos: -1, PwUser: "" }, title);

            const dublicate = this.state.categories.find(cat => cat.Name.trim() == result.Name.trim());;
            if (Helper.hasValue(dublicate)) {
                const msg = Helper.getTranslation("Bookmarks.CategoryAlreadyExists").replace("{x}", dublicate.Name);
                NotificationHelper.showWarningMessage(msg);
                return;
            }

            if (Helper.hasValue(result)) {
                const { Code, Message, Data } = await HTTPService.post<JsonResultClass<IBaseBookmark>>("Bookmark/CreateNewCategory", {
                    category: result
                });
                if (Code != 0) {
                    NotificationHelper.showErrorMessage(Message);
                } else {
                    NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))
                    const categories = this.state.categories;
                    categories.push({
                        Id: Data.Id,
                        Bookmarks: [],
                        Icon: Data.Icon,
                        Name: Data.Name,
                        Pos: Data.Pos,
                        PwUser: Data.PwUser
                    });
                    this.updateCategories(categories);
                    if (categories.length >= this.MAXLENGTH) {
                        NotificationHelper.showWarningMessage(Helper.getTranslation("Bookmarks.MaxLenght").replace("{x}", this.MAXLENGTH.toString()))
                    }

                }
            }
        }

        return (
            <div className="category new_btn" onClick={createNewCategory} title={Helper.getTranslation("Bookmarks.NewCategory")}>
                <i className="fa-sharp fa-solid fa-plus"></i>
            </div>
        );
    }

    private openDialog = <T extends IBaseBookmark>(data: T, title: string) => {
        return new Promise<T>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const root = ReactDOM["createRoot"](targetElement[0]);
            root.render(<BookmarkDialog save={(data: T) => { resolve(data) }} cancel={() => { resolve(null) }} data={data} title={title} />);
        });
    }

    render() {
        return (
            <>
                <div className="category_wrapper">
                    {this.state.categories.map(this.renderCategory)}
                    {this.renderNewCategoryBtn()}
                </div>
            </>
        );
    }
}
interface CategoryProps extends React.PropsWithChildren {
    category: BookmarkCategory;

    draggedBookmark: Bookmark;
    draggedCategory: BookmarkCategory;

    onCategoryDrop: () => void;

    onDragStart: () => void;
    onDragEnd: () => void;
    onDragEnter: () => void;
    onDrop: () => void;

    delete: () => void;
    edit: () => void;
}
interface CategoryState {
    highlightCategory: boolean;
    draggable: boolean;
    hovered: boolean;
}
class Category extends React.Component<CategoryProps, CategoryState>{
    constructor(props: CategoryProps) {
        super(props);
        this.state = {
            highlightCategory: false,
            draggable: false,
            hovered: false
        }
    }

    private cancel = (event) => {
        event.preventDefault();
    }

    private onDragEnter = () => {
        if (Helper.hasValue(this.props.draggedBookmark))
            this.setState({ highlightCategory: true })
    }

    private onDragLeave = () => {
        if (Helper.hasValue(this.props.draggedBookmark) && this.state.highlightCategory) {
            this.setState({ highlightCategory: false })
        }
    }

    private onDrop = () => {
        this.setState({ highlightCategory: false })
        this.props.onCategoryDrop();
    }

    private setDraggable = (value: boolean) => {
        this.setState({ draggable: value })
    }

    private onDragStart = (event) => {
        if (!Helper.hasValue(this.props.draggedBookmark)) {
            event.dataTransfer.effectAllowed = "copyMove";
            this.props.onDragStart();
        }
    }

    private onCategoryDragEnter = (event) => {
        if (!Helper.hasValue(this.props.draggedBookmark)) {
            event.dataTransfer.dropEffect = "copy";
            this.props.onDragEnter();
        }
    }

    private delete = async () => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"), null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"));
        if (isOk)
            this.props.delete();
    }

    private renderHeader = () => {
        let mode = "";
        if (this.props.draggedCategory?.Id == this.props.category.Id) {
            mode = "dragged";
        } else if (!Helper.hasValue(this.props.draggedCategory) && this.state.hovered) {
            mode = "hovered";
        }
        return (
            <>
                <div className={`category__label ${mode}`}
                    onMouseDown={() => { this.setDraggable(true) }}
                    onMouseUp={() => { this.setDraggable(false) }}
                    onMouseOver={() => { this.setState({ hovered: true }) }}
                    onMouseLeave={() => { this.setState({ hovered: false }) }}
                >
                    <div style={{ gridColumn: "1/2", gridRow: "1/2" }}>
                        <i className={`fa-light fa-${this.props.category.Icon} fa-2x`}></i>
                    </div>
                    <div style={{ gridColumn: "2/3", gridRow: "1/2", justifyContent: "flex-start" }}>
                        <label className="truncate">{this.props.category.Name}</label>
                    </div>
                    <div style={{ gridRow: "1/2", gridColumn: "3/4" }} className="category__button" onClick={this.props.edit}>
                        <i className={`fa-light fa-pen`}></i>
                    </div>
                    <div style={{ gridRow: "1/2", gridColumn: "4/5" }} className="category__button" onClick={this.delete}>
                        <i className={`fa-light fa-trash`}></i>
                    </div>
                </div>

            </>
        );
    }

    render() {
        const remainingSpace = 60;
        return (
            <>
                <div
                    className={"category" + (this.state.highlightCategory ? " highlight" : "")}
                    draggable={this.state.draggable ? "true" : "false"}
                    onDragStart={this.onDragStart}
                    onDragEnter={this.onCategoryDragEnter}
                    onDragOver={this.cancel}
                    onDrop={this.props.onDrop}
                    onDragEnd={this.props.onDragEnd}
                >
                    {this.renderHeader()}
                    <div style={{ overflow: "auto", maxHeight: `calc(100% - 50px - ${remainingSpace}px)` }}>
                        {this.props.children}
                    </div>
                    <div className="category__remaining" onDrop={this.onDrop} onDragEnter={this.onDragEnter} onDragLeave={this.onDragLeave} onDragOver={this.cancel} ></div>
                </div>
            </>
        );
    }
}
interface BookmarkProps {
    bookmark: Bookmark;
    draggedId: string;


    onDragStart: () => void;
    onDragEnd: () => void;
    onDragEnter: () => void;
    onDrop: () => void;

    delete: () => void;
    edit: () => void;
}
interface BookmarkViewState {
    hover: boolean;
}
class BookmarkView extends React.Component<BookmarkProps, BookmarkViewState>{
    constructor(props) {
        super(props)
        this.state = {
            hover: false,
        }
    }

    private onDragStart = (event) => {
        event.dataTransfer.effectAllowed = "copyMove";
        this.props.onDragStart();
    }

    private onDragEnter = (event) => {
        event.dataTransfer.dropEffect = "copy";
        this.props.onDragEnter();
    }

    private cancel = (event) => {
        event.preventDefault();
    }

    private onMouseOver = () => {
        this.setState({ hover: true })
    }

    private onMouseLeave = () => {
        this.setState({ hover: false })
    }

    private delete = async () => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"), null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"));
        if (isOk)
            this.props.delete();
    }

    render() {
        const { bookmark, onDragEnd, edit, onDrop } = this.props;
        let mode = "";
        if (this.props.draggedId == bookmark.Id) {
            mode = "dragged";
        } else if (Helper.isNullOrEmpty(this.props.draggedId) && this.state.hover) {
            mode = "hovered";
        }

        return (
            <div className={`bookmark ${mode}`}
                key={bookmark.Id}
                data-id={bookmark.Id}
                draggable={"true"}
                onDragStart={this.onDragStart}
                onDragEnd={onDragEnd}
                onDragEnter={this.onDragEnter}
                onDragOver={this.cancel}
                onMouseOver={this.onMouseOver}
                onMouseLeave={this.onMouseLeave}
                onDrop={onDrop}
            >
                <div style={{ gridRow: "1/2", gridColumn: "1/2" }}>
                    <i className={`fa-light fa-${bookmark.Icon}`}></i>
                </div>
                <div style={{ gridRow: "1/2", gridColumn: "2/3", justifyContent: "flex-start", margin: "0 5px" }} >
                    <label className="truncate">{bookmark.Name}</label>
                </div>
                <div style={{ gridRow: "1/2", gridColumn: "3/4" }} className="bookmark__button" onClick={edit}>
                    <i className={`fa-light fa-pen`}></i>
                </div>
                <div style={{ gridRow: "1/2", gridColumn: "4/5" }} className="bookmark__button" onClick={this.delete}>
                    <i className={`fa-light fa-trash`}></i>
                </div>
            </div>
        );
    }
}

interface BookmarkDialogProps {
    data: IBaseBookmark;
    save: (data: IBaseBookmark) => void;
    cancel: () => void;
    title: string;
}
class BookmarkDialog extends React.Component<BookmarkDialogProps, { icon: string, name: string, url?: string }>{
    private dialogRef: Dialog;
    private dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.cancel();
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.save();
                },
                primary: true
            }
        ],
        open: true,
        afterClose: () => { },
        width: 500
    };
    private factory = ComponentHelper.createFactory();
    private containsURL: boolean;
    constructor(props) {
        super(props)
        const url = (this.props.data as Bookmark)?.URL;
        this.containsURL = !Helper.isNullOrEmpty(url);
        this.state = {
            icon: this.props.data.Icon,
            name: this.props.data.Name,
            url: url
        }
    }

    private save = async () => {
        const data: IBaseBookmark = JSON.parse(JSON.stringify(this.props.data));
        data.Icon = this.state.icon;
        data.Name = this.state.name;
        if (this.containsURL)
            data["URL"] = this.state.url;
        this.props.save(data);
    }

    private renderIconTextBox = () => {
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Icon.Icon")} noHover={true}>
                <IconPicker value={this.state.icon} onChange={(value) => { this.setState({ icon: value }) }} dataSourceUrl={"Bookmark/GetIcons"} />
            </FieldInstance>
        );
    }

    private checkButtonAvailability = () => {
        const button = document.querySelector(".k-dialog button.k-button.k-button-solid-primary");
        if (Helper.isNullOrEmpty(this.state.name) || Helper.isNullOrEmpty(this.state.icon) || (this.containsURL && Helper.isNullOrEmpty(this.state.url))) {
            button.setAttribute("disabled", "disabled")
        } else {
            button.removeAttribute("disabled");
        }
    }

    private renderNameTextbox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.name;
        props.onChange = (_, value) => {
            this.setState({ name: value })
        }
        props.field.triggerOnChange = true;
        return (
            <FieldInstance label={Helper.getTranslation("BrowserTitle.Resource.Available")} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );

    }

    private renderURLTextBox = () => {
        if (!this.containsURL)
            return null;

        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.url;
        props.onChange = (_, value) => {
            this.setState({ url: value })
        }
        props.field.triggerOnChange = true;
        return (
            <FieldInstance label={Helper.getTranslation("MST.Settings.Url")} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    componentDidMount() {
        const dialog: HTMLDivElement = document.querySelector("div.k-dialog");
        dialog.style.top = (window.innerHeight / 4) + "px";
        this.checkButtonAvailability();
    }

    componentDidUpdate() {
        this.checkButtonAvailability();
    }

    render() {
        return (
            <Dialog {...this.dialogProps} ref={(ref) => { this.dialogRef = ref }} title={this.props.title}>
                {this.renderIconTextBox()}
                {this.renderNameTextbox()}
                {this.renderURLTextBox()}
            </Dialog>
        );
    }
}
class BookmarkService {
    public static async updateCategories(categoryA, categoryB) {
        return new Promise<void>(async (resolve) => {
            if (Helper.hasValue(categoryA) || Helper.hasValue(categoryB)) {

                const categories = [
                    categoryA
                ]
                if (Helper.hasValue(categoryB))
                    categories.push(categoryB)
                const result = await HTTPService.post<JsonResultClass>("Bookmark/UpdateCategories", {
                    categories: categories
                });
                NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))
            }
            resolve();
        })
    }
}